module.exports = __webpack_public_path__ + "img/undraw_art_museum_8or4.1e63d3c7.svg";